import $ from 'cash-dom';

export default () => {
  const $menuOpener = $('.js-menu-opener');
  const $menu = $('.js-menu');

  $menuOpener.on('click', () => {
    if ($menuOpener.hasClass('is-active')) {
      $menuOpener.removeClass('is-active');
      $menu.removeClass('is-active');
    } else {
      $menuOpener.addClass('is-active');
      $menu.addClass('is-active');
    }
  });

  let topPartHeight = $('.intro').height(); // header + intro
  const logoHeight = $('.header__logo').height();
  /* ==========================================
  scrollTop() >= topPartHeight
  Should be equal the the height of the header
  ========================================== */
  $(window).on('scroll', () => {
    const $header = $('header');
    if (window.scrollY >= topPartHeight - logoHeight) {
      if (!$header.hasClass('hideLogo')) {
        $header.addClass('hideLogo');
        topPartHeight = $('.intro').height(); // header + intro
      }
    } else if ($header.hasClass('hideLogo')) {
      $header.removeClass('hideLogo');
      topPartHeight = $('.intro').height(); // header + intro
    }

    if (window.scrollY >= topPartHeight) {
      if (!$header.hasClass('withBG')) {
        $header.addClass('withBG');
      }
    } else if ($header.hasClass('withBG')) {
      $header.removeClass('withBG');
    }
  });
};
